/**
 * @name PageTime
 * @namespace /reservation/time
 * hier soll die eingabe vom nutzer für die buchung durchgeführt werden
 *
 * - Starttime und Endtime müssen min params('IAPP_MIN_DURATION') außereinander sein
 *
 */
<template>
	<div id="PageTime">
		<div class="container content-time">
			<div class="row">
				<div class="col-12">
					<div class="wrapper-headlines">
						<div class="row justify-content-center">
							<div class="col-md-12 col-lg-auto">
								<h1 class="d-inline-block">{{ $t('Select the period') }}</h1>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col wrapper-rounded-content">
					<div class="bg-blue-multiply rounded-corners"></div>
					<div class="row justify-content-center align-items-center">

						<div class="col-sm-auto">
							<h4>{{ $t('Pick-up time') }}</h4>

							<div class="btn-group">
								<Datepicker
								ref="startdate"

								v-model="start_date"
								@change="datechange('start_date')"
								:disabled_dates="start_station.holidays"
								></Datepicker>
								<Timepicker
								ref="start_time"
								@change="datechange('start_time')"
								:mintime="start_day_schedule().btime"
								:maxtime="start_day_schedule().etime"
								v-model="start_time"
								></Timepicker>
							</div>
						</div>

						<div class="col-sm-auto">
							<h4>{{ $t('Drop-off time') }}</h4>

							<div class="btn-group">
								<Datepicker
								ref="enddate"

								:mindate="start_date"
								v-model="end_date"
								@change="datechange('end_date')"
								:disabled_dates="end_station.holidays"
								></Datepicker>
								<Timepicker
								ref="end_time"
								@change="datechange('end_time')"
								:mintime="end_day_schedule().btime"
								:maxtime="end_day_schedule().etime"
								v-model="end_time"
								></Timepicker>
							</div>
						</div>

						<div class="w-100"></div>
						<div class="col-sm-auto">
							<h4>{{ $t('Planned kilometres') }}</h4>

							<div class="max-input">
								<CsInput

								autocomplete="billing given-name"

								:placeholder="$t('Kilometer')"
								:id="'distance'"
								:name="'distance'"
								v-model="distance"
								></CsInput>

							</div>

						</div>

						<div class="col-sm-auto inv-helper">
							&nbsp;
						</div>

						<div class="row d-none d-lg-block" style="margin-top:20px;">


							<div class="col text-center col-cta-button" >
								<button @click="nextPage" type="button" class="btn btn-primary btn-wp">
									{{ $t('Continue to vehicle selection') }}
								</button>
							</div>
						</div>
					</div>



				</div>
			</div>
			<div class="row">
				<div class="col text-center col-cta-button d-lg-none">
					<button @click="nextPage" type="button" class="btn btn-primary btn-wp">
						{{ $t('Continue to vehicle selection') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import formatter 		from '@/store/orm/helpers/formater';
import {getDefaultStartdate, getDefaultEnddate} from '@/store/orm/config'
import find from 'lodash/find';
import { mapGetters } from 'vuex'
export default {
	name: 'PageTime',
	data() {
		return {
			start_date: false,
			start_time: false,
			end_date: false,
			end_time: false,
			distance: 0

		}
	},
	computed: {
		start_station(){
			return this.$store.getters['orm/reservation/startstation'];
		},
		end_station(){
			return this.$store.getters['orm/reservation/endstation'];
		},

		

	    ...mapGetters('orm/reservation', [
	    	'user_session',
			'station',
	    ]),
	    // map core functions
	    ...mapGetters('orm', [
	      'stations'
	    ]),
	},
	beforeMount(){
		if (this.$route.params.stationid) {
			this.$store.dispatch('orm/GET_STATIONS')
			.then(stations => {

			  if(this.$store.getters['orm/station'](this.$route.params.stationid)){
			this.$store.commit('orm/reservation/SET_STATION', this.$route.params.stationid);
			}else{
				if(!this.start_station){
					this.$router.push({ name: 'PagePlace', params: this.$route.params}); return;
				}
				if(!this.end_station){
					this.$router.push({ name: 'PagePlace', params: this.$route.params}); return;
				}
			}
			})
			.catch(err => { this.$store.commit("core/ADD_ERROR", 'stations'+err); })
		}else{

			if(!this.start_station){
				this.$router.push({ name: 'PagePlace', params: this.$route.params}); return;
			}
			if(!this.end_station){
				this.$router.push({ name: 'PagePlace', params: this.$route.params}); return;
			}
		}
	},
	mounted(){

		const start_date = this.$store.getters['orm/reservation/startdate'],
			  end_date = this.$store.getters['orm/reservation/enddate'];


		if(start_date && start_date != this.start_date) {
			this.start_date = start_date;
		} else {
			this.start_date = getDefaultStartdate();
		}
		this.start_time = formatter.OUTPUT_DATE_ONLY_TIME(this.start_date);




		if(end_date && end_date != this.end_date) {
			this.end_date = end_date;
		} else {
			this.end_date = getDefaultEnddate();
		}

		this.end_time = formatter.OUTPUT_DATE_ONLY_TIME(this.end_date);

	},

	methods: {
		start_day_schedule(){
			console.log("this.station.schedule",this.station.schedule);
			if(!this.start_date) return [];

			var dayOfWeek = this.start_date.getDay();
			return find(this.station.schedule, (sch) => {
				return sch.dayOfWeek == dayOfWeek
			});
		},

		end_day_schedule(){
			console.log("this.end_day_schedule.schedule",this.station.schedule);
			if(!this.end_date) return [];

			var dayOfWeek = this.end_date.getDay();
			return find(this.station.schedule, (sch) => {
				return sch.dayOfWeek == dayOfWeek
			});
		},
		setTimeOnDate(date, time){
			if(!time) throw "time muss ein string sein ;)"
			var hou = 0, min = 0;
			if(typeof time == 'string'){
				var a = time.split(':');

				hou = a[0]
				min = a[1]
			} else {
				hou = time.getHours();
				min = time.getMinutes();
			}
			date.setHours(hou, min);

			return date;
		},
		addHour(time,addHour){
			var a = time.split(':');
			let h = parseInt(a[0]) + addHour;
			let min = a[1];
			return h + ':' + min;
		},
		formatTime(time){
			var a = time.split(':');
			let h = a[0];
			let min = a[1];
			return h+min;
		},
		datechange(ev) {

			console.log('EV',ev);

			let start_date = this.start_date;
			let end_date = this.end_date;
			let start_time = this.start_time;
			let end_time = this.end_time;

			switch (ev) {
				case 'start_date':
				   	start_date = this.setTimeOnDate(start_date, start_time);
				    if (start_date < end_date) {
						break;
					}
				case 'end_date':
					this.end_date = this.setTimeOnDate(end_date, end_time);
					break;								    
				case 'start_time':
				    start_date = this.setTimeOnDate(start_date, start_time);
				    break;
				case 'end_time':
				    this.end_date = this.setTimeOnDate(end_date, end_time);
					break;
			}
			if (this.start_date >= this.end_date) {
				let newDate = new Date(this.start_date);
				if (this.formatTime(this.start_time) > this.formatTime(this.end_time)) {
					this.end_date = this.setTimeOnDate(newDate, this.addHour(start_time,1));
					this.end_time = formatter.OUTPUT_DATE_ONLY_TIME(this.end_date);
				}else{
					this.end_date = this.setTimeOnDate(newDate, this.end_time);
				}
			}
		},

		/**
		 * brings you to the next page
		 */
		nextPage(){
			var start_date = this.start_date;

			start_date = this.setTimeOnDate(start_date, this.start_time);
			this.$store.commit('orm/reservation/SET_STARTDATE', start_date);


			var end_date = this.end_date;
			end_date = this.setTimeOnDate(end_date, this.end_time);
			this.$store.commit('orm/reservation/SET_ENDDATE', end_date);

			this.$store.commit('orm/reservation/SET_ESTIMATED_KM', this.distance);

			
			if(!this.user_session) {
				this.$router.push({name: "PageLogin", params: {redirect: 'PageCar' }});
			} else {

				this.$store.dispatch('orm/GET_CUSTOMER')
				.then(result => {

					var bill_recipient = result.bill_recipient;
					if(bill_recipient === null){
						bill_recipient = 0;
					}
					if(this.$store.getters['orm/reservation/startstation'].private_reservations && bill_recipient != 0){
						this.$router.push({
						name: 'PageRentaltypes'
					});
					}else{
						this.$router.push({
						name: 'PageCar'
					});
					}

				}).catch(err => { this.$store.commit("core/ADD_ERROR", err); });
				
				
				
			}


		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Pages/PageTime.vue